import { Component, Injector, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseChartComponent } from '../base-chart-component/base-chart.component';
import { ChartType } from 'src/app/shared/common';
import { NgChartsModule } from 'ng2-charts';
import { ChartData } from 'chart.js';
import { BaseChart } from 'src/app/core/data/model';

@Component({
  selector: 'app-pie-chart',
  standalone: true,
  imports: [CommonModule, NgChartsModule],
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
})
export class PieChartComponent extends BaseChartComponent<BaseChart> implements OnInit {
  override chartType: ChartType = ChartType.PIE;
  chartData: ChartData<ChartType.PIE, number[] | string[], string | string[]>;
  @Input() unit: string = '%';

  constructor(injector: Injector) {
    super(injector);
  }

  // hooks
  override ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.["data"]){
      this.buildChartData();
      this.setChartConfigs()
    }
  }

  // protected
  protected override buildChartData(): void {
    this.chartData = {
      labels: this.labels,
      datasets: this.data?.map((dataItem) => {
        const dataSetItem: any = {};
        dataSetItem['data'] = [...dataItem['dataSet']];
        dataSetItem['backgroundColor'] = dataItem['backgroundColor'];
        dataSetItem['label'] = dataItem['label'];
        dataSetItem['borderColor'] = 'white';
        dataSetItem['borderWidth'] = 2;
        return dataSetItem;
      }),
    };
  }

  override setChartConfigs(): void {
    super.setChartConfigs();
    this.chartOptions.plugins.tooltip = {
        enabled: true,
        callbacks: {
          label: (context) => {
            let label = context.formattedValue || '';
            return label + this.unit;
        },
      }
    }
  }
}
